/*
 * Get Futsal — Package Protection toggle (real, billable add-on).
 * One delegated change-listener powers the protection checkbox in BOTH the cart
 * drawer and the cart page. Checking the box adds the real $4.99 protection
 * variant to the cart (it bills); unchecking removes it. Uses the Shopify Section
 * Rendering API so the drawer re-renders in place; the cart page reloads. Event
 * delegation on document means it survives the drawer's DOM swaps with no re-bind.
 *
 * The variant id comes from each checkbox's data-protection-variant-id attribute,
 * set from snippets/gf-protection-variant-id.liquid. If no id is configured the
 * toggle is inert (reverts + warns) so the UI never implies a charge that cannot
 * happen. Opt-in only: there is no pre-check (a pre-ticked paid box is an EU CRD
 * Art. 22 violation / FTC dark pattern).
 */
(function () {
  if (window.__gfPackageProtectionInit) return;
  window.__gfPackageProtectionInit = true;

  var CHECKBOX = '.gf-package-protection__checkbox';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function jsonHeaders() {
    return { 'Content-Type': 'application/json', Accept: 'application/json' };
  }

  function hostDrawer(checkbox) {
    return checkbox.closest('cart-drawer');
  }

  function sectionsFor(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        return drawer.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) {}
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function applyState(drawer, state) {
    if (drawer && state && state.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
    } else {
      window.location.reload();
    }
  }

  function postJSON(url, payload) {
    return fetch(root() + url, {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (!res.ok) throw new Error(url + ' -> ' + res.status);
      return res.json();
    });
  }

  function addProtection(variantId, drawer) {
    var payload = { id: variantId, quantity: 1 };
    if (drawer) {
      payload.sections = sectionsFor(drawer);
      payload.sections_url = window.location.pathname;
    }
    return postJSON('cart/add.js', payload).then(function (state) {
      applyState(drawer, state);
    });
  }

  function removeProtection(variantId, drawer) {
    // Resolve the line item key for this variant, then set its quantity to 0.
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var key = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (String(cart.items[i].id) === String(variantId)) { key = cart.items[i].key; break; }
        }
        if (!key) {
          if (drawer) return; // drawer already reflects no protection
          window.location.reload();
          return;
        }
        var payload = { id: key, quantity: 0 };
        if (drawer) {
          payload.sections = sectionsFor(drawer);
          payload.sections_url = window.location.pathname;
        }
        return postJSON('cart/change.js', payload).then(function (state) {
          applyState(drawer, state);
        });
      });
  }

  function onToggle(checkbox) {
    var variantId = (checkbox.getAttribute('data-protection-variant-id') || '').trim();
    var wantOn = checkbox.checked;
    if (!variantId) {
      console.warn('[Package Protection] No variant id set in snippets/gf-protection-variant-id.liquid — toggle is inert until the owner pastes the id.');
      checkbox.checked = false;
      return;
    }
    if (checkbox.dataset.gfBusy === 'true') return;
    checkbox.dataset.gfBusy = 'true';
    checkbox.style.pointerEvents = 'none';

    var drawer = hostDrawer(checkbox);
    var work = wantOn ? addProtection(variantId, drawer) : removeProtection(variantId, drawer);

    Promise.resolve(work)
      .catch(function (err) {
        console.error('[Package Protection] update failed', err);
        checkbox.checked = !wantOn; // revert so the UI never lies about the charge
      })
      .then(function () {
        checkbox.dataset.gfBusy = 'false';
        checkbox.style.pointerEvents = '';
      });
  }

  document.addEventListener('change', function (e) {
    var checkbox = e.target && e.target.closest ? e.target.closest(CHECKBOX) : null;
    if (checkbox) onToggle(checkbox);
  });
})();
